class Tabs extends HTMLElement {
  constructor() {
    super();

    this.tabs = this.querySelectorAll(".js-tab");
    this.tabContents = this.querySelectorAll(".js-tab-content");
    this.activeTab = this.querySelector(".tabs__tab--active");
    this.activeContent = this.querySelector(".tabs__content--active");
    this.publish = this.dataset.publish;
    this.addListeners();
  }

  addListeners() {
    this.tabs.forEach((tab) =>
      tab.addEventListener("click", () => this.toggleTab(tab))
    );
  }

  toggleTab(tab) {
    tab.classList.add("tabs__tab--active");
    if (tab !== this.activeTab) {
      this.activeContent.classList.remove("tabs__content--active");
      this.activeTab.classList.remove("tabs__tab--active");
      this.activeTab = tab;

      if (this.publish) publish(PUB_SUB_EVENTS.tabOpen, { tab: tab });

      this.tabContents.forEach((content) => {
        if (content.dataset.content === this.activeTab.dataset.tab) {
          this.activeContent = content;
          this.activeContent.classList.add("tabs__content--active");
        }
      });
    }
  }
}

customElements.define("tabs-wrapper", Tabs);
